import { createContext, useContext } from "react";

const EVENTS_BASE_PATH_DEFAULT = "/events";

export const EventsBasePathContext = createContext<string>(EVENTS_BASE_PATH_DEFAULT);

export function useEventsBasePath(): string {
  return useContext(EventsBasePathContext);
}

/** University event detail routes (single ObjectHeading) vs list/new (UniversityHeading). */
export function isUniversityEventDetailPath(pathname: string, eventsBasePath: string): boolean {
  if (!eventsBasePath.startsWith("/education/universities/")) {
    return false;
  }

  const prefix = `${eventsBasePath}/`;
  if (!pathname.startsWith(prefix)) {
    return false;
  }

  const remainder = pathname.slice(prefix.length);
  if (!remainder || remainder === "new") {
    return false;
  }

  return true;
}
